import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

import type {
  UserSearchRequestParams,
  JsonObject,
  UserSearchResponseBody,
} from '@/app-package';

// TODO: Remove this type and use the one from the app package
export type SearchParams = {
  name: string;
  orgId?: string;
  excludeInternalOrgs: boolean;
  isCrossOrgSearch?: boolean;
  isLicensed?: boolean;
  size?: number;
  page?: number;
  includeUnverified?: boolean;
  listingId?: string;
  includeCustomAgents?: boolean;
};

const getSearch = async (params: SearchParams) => {
  const config: AxiosRequestConfig = {
    url: '/user/search',
    method: 'get',
    params,
  };

  const { data } =
    await axios.request<JsonObject<UserSearchResponseBody>>(config);

  return data;
};

export default getSearch;
